import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../resources/requestInfo";

import { changeDataProfileRoutes } from "./routes";

export const fetchEditName = createAsyncThunk<string, { name: string }>(
  "editName/fetcheditName",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(changeDataProfileRoutes.CHANGE_NAME, data);
      return response.status === 200 && response.statusText === "OK" ? "OK" : "ERROR";
    } catch (error: any) {
      return rejectWithValue(error.response?.status || "Ошибка изменения имени");
    }
  }
);

export const fetchEditEmail = createAsyncThunk<string, { email: string }>(
    "editEmail/fetchedEmail",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(changeDataProfileRoutes.GET_CODE_EMAIL, data);
            return response.status === 200 && response.statusText === "OK" ? "OK" : "ERROR";
        } catch (error: any) {
            return rejectWithValue(error.response?.status || "Ошибка запроса кода для изменения email");
        }
    }
);

export const fetchSendEmailCode = createAsyncThunk<string, { email: string, code: string}>(
    "getCodel/fetchedEmail",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(changeDataProfileRoutes.CHANGE_EMAIL, data);
            return response.status === 200 && response.statusText === "OK" ? "OK" : "ERROR";
        } catch (error: any) {
            return rejectWithValue(error.response?.status || "Ошибка подтверждения изменения email");
        }
    }
);

export const fetchEditPhone = createAsyncThunk<string, { phone: string}>(
    "editPhone/fetchedPhone",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(changeDataProfileRoutes.CHANGE_PHONE, data);
            return response.status === 200 && response.statusText === "OK" ? "OK" : "ERROR";
        } catch (error: any) {
            return rejectWithValue(error.response?.status || "Ошибка изменения телефона");
        }
    }
);